import PropTypes from 'prop-types';

import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import Stack from '@zenbusiness/zui/Stack';
import useBreakpoints from '@zenbusiness/zui/useBreakpoints';

import CalloutAsset from '#client/components/CalloutAsset';
import PageHeader from '#client/components/PageHeader';
import SingleChoiceSelection from '#client/components/SingleChoiceSelection';
import useFlowState from '#client/hooks/flow/useFlowState';
import useFlowNavigation from '#client/hooks/useFlowNavigation';
import TwoColumnLayout from '#client/layouts/TwoColumnLayout';

export const OPTIONS = {
  planningFuture: 'planning-future',
  launchingSoon: 'launching-soon',
  makingMoney: 'making-money'
};

export const getChoices = (formatMessage) => {
  return Object.entries(OPTIONS).map(([key, value]) => ({
    value,
    label: formatMessage({ id: `shopping.page.businessStage.option.${key}.label` })
  }));
};

function BusinessStage({ calloutAssetProps, hideSkipButton }) {
  const { sizes } = useBreakpoints();
  const { goToNextPage } = useFlowNavigation();
  const { businessInfo, set } = useFlowState();
  const { formatMessage } = useIntl();
  const { isMobile } = sizes;

  const handleOnActionClick = (option = null) => {
    set('businessInfo.businessStage', option);
    goToNextPage();
  };

  return (
    <TwoColumnLayout>
      <TwoColumnLayout.SmallColumn>
        <PageHeader title={<FormattedMessage id="shopping.page.businessStage.title" />} />
        <SingleChoiceSelection
          defaultValue={OPTIONS.planningFuture}
          options={getChoices(formatMessage)}
          primaryAction={{
            label: formatMessage({ id: 'shopping.page.businessStage.primaryAction.label' }),
            clickstreamProps: {
              elementName: 'business_stage_primary_action'
            },
            'data-testid': 'business-stage-primary-action',
            onClick: handleOnActionClick
          }}
          secondaryAction={
            !hideSkipButton && {
              label: formatMessage({ id: 'shopping.page.businessStage.secondaryAction.label' }),
              clickstreamProps: {
                elementName: 'business_stage_secondary_action'
              },
              'data-testid': 'business-stage-secondary-action',
              onClick: handleOnActionClick
            }
          }
          value={businessInfo.businessStage}
        />
      </TwoColumnLayout.SmallColumn>
      <TwoColumnLayout.LargeColumn>
        <Stack spacing={2}>
          <CalloutAsset
            alt="business stage"
            name="funnel-questionnaire-stage"
            show={!isMobile}
            {...calloutAssetProps}
          />
        </Stack>
      </TwoColumnLayout.LargeColumn>
    </TwoColumnLayout>
  );
}

BusinessStage.propTypes = {
  calloutAssetProps: PropTypes.object,
  hideSkipButton: PropTypes.bool
};

export default BusinessStage;
